import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { UserCardCreateState } from "../../model/Systemparameters";
import { DocumentArrowUpIcon } from "@heroicons/react/24/solid";

export type UserIdcardFileDeleteModalProps = {
  userCardCreateState?: UserCardCreateState;
  handle: (id: string, file: File | null) => void;
}

export const UserIdcardFileDeleteModal = ({
  open,
  toggle,
  closeOnClickOutside,
  userCardCreateState,
  handle,
}: ModalProp & UserIdcardFileDeleteModalProps) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          {(userCardCreateState !== undefined) ? (
          <>
            <div className="px-2 pb-4 sm:p-4">
              <div className="text-center sm:mt-3">
                <Dialog.Title
                  as="h3"
                  className="text-left  text-lg font-medium leading-6 text-gray-900"
                >
                削除
                </Dialog.Title>
              </div>
              <div className="mt-5">
                アップロードした以下のExcelファイルを削除しますか？
              </div>
              <ul style={{ color:"green"}}>
              <li className={"flex"}>
              <DocumentArrowUpIcon className={"h-6 w-6 bold"} />
              {userCardCreateState.dispExcelFileName}
              </li>
              </ul>
            </div>
            <ModalFoterBox>
              <Button
                className="mx-2 mt-1 w-[132px]"
                outline
                onClick={toggle}
              >
                キャンセル
              </Button>
              <Button
                className="mt-1 mr-2 w-[132px]"
                color="red"
                onClick={() => 
                handle(userCardCreateState.id, null)
                }>
                  削除
                  </Button>
            </ModalFoterBox>
          </>
          ): (<></>)}
        </Dialog.Panel>
      </Modal>
    </>
  );
}
